export const statusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return '#F0AD4E'
    case 'PENDING_HR':
      return '#F0AD4E'
    case 'APPROVED':
      return '#5CB85C'
    case 'REJECTED':
      return '#D44B49'
    case 'UNSUBMITTED':
      return '#BBBBBB'
    case 'NONSUBMIT':
      return '#BBBBBB'
    case 'CANCEL':
      return '#BBBBBB'
    default:
      return null
  }
}

export const leaveColor = (status) => {
  switch (status) {
    case 'HOLIDAY':
      return '#7B7B7B'
    case 'WEEKEND':
      return '#EBEBEB'
    case 'FULLDAY':
      return '#222222'
    case 'COMPENSATE':
      return '#0071BD'
    case 'AM':
      return '#FBFF7A'
    case 'PM':
      return '#FBFF7A'
    default:
      return null
  }
}

export const approveStatus = (status) => {
  switch (status) {
    case 'NONSUBMIT':
      return 'UNSUBMITTED'
    default:
      return status
  }
}




// WEBPACK FOOTER //
// ./src/components/my-leave/helpers/color.js